import * as React from 'react';
import Header from 'app/components/HeaderComponent';
import Footer from 'app/components/FooterComponent';
import { Box, Button, Paper, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="app-content not-found-page">
    <Header />
    <Box className="modern-empty-state" component="main">
      <Paper className="modern-empty-state-card" elevation={0}>
        <Typography variant="overline">404</Typography>
        <Typography variant="h3">Page Not Found</Typography>
        <Typography variant="body1">
          The page you are looking for is unavailable or may have moved.
        </Typography>
        <Box className="modern-empty-state-actions">
          <Button component={Link} to="/" variant="contained">Go Home</Button>
          <Button component={Link} to="/yourprojects" variant="outlined">View Your Projects</Button>
        </Box>
      </Paper>
    </Box>
    <Footer />
  </div>
);

export default NotFound;
